console.log('Miami. Joeboy. Quick study.');
